import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { useNavState } from '@/lib/nav-state';
import { ResetPasswordScreen } from '@/screens/auth/ResetPasswordScreen';

/**
 * The emailed link is /reset-password?token=…. On arrival the token moves into history
 * state and the entry is replaced by plain /reset-password, so the token stays in neither
 * the address bar nor the history list.
 */
export const Route = createFileRoute('/_auth/reset-password')({
  validateSearch: z.object({ token: z.string().optional() }),
  beforeLoad: ({ search }) => {
    if (search.token) {
      throw redirect({
        to: '/reset-password',
        search: {},
        state: { resetToken: search.token },
        replace: true,
      });
    }
  },
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { resetToken } = useNavState();
  return <ResetPasswordScreen token={resetToken} />;
}
